import "./App.css";
import { Fragment } from "react";
import Slider from "./Slider";

function App() {
  return (
    <div>
      <Fragment>
        <Slider />
      </Fragment>
    </div>
  );
}

export default App;
